module.exports = __webpack_public_path__ + "img/goods-mobile-2.65ee27d1.png";